"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FONT_SIZE = exports.E_FONT_SIZE_KEYS = exports.E_FONT_WEIGHT = exports.E_FONT_FAMILY = void 0;
const basic_1 = require("../basic");
var E_FONT_FAMILY;
(function (E_FONT_FAMILY) {
    E_FONT_FAMILY["DEFAULT"] = "\"aktiv-grotesk\", sans-serif";
    E_FONT_FAMILY["TITLE"] = "\"PPAgrandir\", sans-serif";
})(E_FONT_FAMILY || (exports.E_FONT_FAMILY = E_FONT_FAMILY = {}));
var E_FONT_WEIGHT;
(function (E_FONT_WEIGHT) {
    E_FONT_WEIGHT[E_FONT_WEIGHT["LIGHT"] = 300] = "LIGHT";
    E_FONT_WEIGHT[E_FONT_WEIGHT["REGULAR"] = 400] = "REGULAR";
    E_FONT_WEIGHT[E_FONT_WEIGHT["MEDIUM"] = 500] = "MEDIUM";
    E_FONT_WEIGHT[E_FONT_WEIGHT["BOLD"] = 700] = "BOLD";
})(E_FONT_WEIGHT || (exports.E_FONT_WEIGHT = E_FONT_WEIGHT = {}));
var E_FONT_SIZE_KEYS;
(function (E_FONT_SIZE_KEYS) {
    E_FONT_SIZE_KEYS["XL"] = "XL";
    E_FONT_SIZE_KEYS["L"] = "L";
    E_FONT_SIZE_KEYS["M"] = "M";
    E_FONT_SIZE_KEYS["S"] = "S";
    E_FONT_SIZE_KEYS["XS"] = "XS";
    E_FONT_SIZE_KEYS["LARGE"] = "LARGE";
    E_FONT_SIZE_KEYS["LARGE_BOLD"] = "LARGE_BOLD";
    E_FONT_SIZE_KEYS["MEDIUM"] = "MEDIUM";
    E_FONT_SIZE_KEYS["MEDIUM_BOLD"] = "MEDIUM_BOLD";
    E_FONT_SIZE_KEYS["SMALL"] = "SMALL";
    E_FONT_SIZE_KEYS["SMALL_BOLD"] = "SMALL_BOLD";
    E_FONT_SIZE_KEYS["SMALLER"] = "SMALLER";
    E_FONT_SIZE_KEYS["SMALLER_BOLD"] = "SMALLER_BOLD";
    E_FONT_SIZE_KEYS["LINK_LARGE"] = "LINK_LARGE";
    E_FONT_SIZE_KEYS["LINK_LARGE_BOLD"] = "LINK_LARGE_BOLD";
    E_FONT_SIZE_KEYS["LINK_MEDIUM"] = "LINK_MEDIUM";
    E_FONT_SIZE_KEYS["LINK_MEDIUM_BOLD"] = "LINK_MEDIUM_BOLD";
    E_FONT_SIZE_KEYS["LINK_SMALL"] = "LINK_SMALL";
    E_FONT_SIZE_KEYS["LINK_SMALL_BOLD"] = "LINK_SMALL_BOLD";
    E_FONT_SIZE_KEYS["NAVIGATION"] = "NAVIGATION";
    E_FONT_SIZE_KEYS["BUTTON"] = "BUTTON";
    E_FONT_SIZE_KEYS["TABS"] = "TABS";
})(E_FONT_SIZE_KEYS || (exports.E_FONT_SIZE_KEYS = E_FONT_SIZE_KEYS = {}));
exports.FONT_SIZE = (0, basic_1.applyBase)({
    [E_FONT_SIZE_KEYS.XL]: {
        fontSize: ['34px', '52px'],
        lineHeight: ['46px', '70px'],
        fontWeight: E_FONT_WEIGHT.MEDIUM,
        fontFamily: E_FONT_FAMILY.TITLE,
    },
    [E_FONT_SIZE_KEYS.L]: {
        fontSize: ['26px', '34px'],
        lineHeight: ['38px', '48px'],
        fontWeight: E_FONT_WEIGHT.MEDIUM,
        fontFamily: E_FONT_FAMILY.TITLE,
    },
    [E_FONT_SIZE_KEYS.M]: {
        fontSize: ['21px', '27px'],
        lineHeight: ['32px', '42px'],
        fontWeight: E_FONT_WEIGHT.MEDIUM,
        fontFamily: E_FONT_FAMILY.TITLE,
    },
    [E_FONT_SIZE_KEYS.S]: {
        fontSize: ['19px', '21px'],
        lineHeight: ['28px', '34px'],
        fontWeight: E_FONT_WEIGHT.MEDIUM,
        fontFamily: E_FONT_FAMILY.TITLE,
    },
    [E_FONT_SIZE_KEYS.XS]: {
        fontSize: ['16px', '19px'],
        lineHeight: ['24px', '28px'],
        fontFamily: E_FONT_FAMILY.DEFAULT,
        fontWeight: E_FONT_WEIGHT.BOLD,
    },
    [E_FONT_SIZE_KEYS.LARGE_BOLD]: {
        fontSize: ['16px', '18px'],
        lineHeight: ['24px', '28px'],
        fontWeight: E_FONT_WEIGHT.BOLD,
    },
    [E_FONT_SIZE_KEYS.LARGE]: {
        fontSize: ['16px', '18px'],
        lineHeight: ['24px', '28px'],
        fontWeight: E_FONT_WEIGHT.REGULAR,
    },
    [E_FONT_SIZE_KEYS.MEDIUM]: {
        fontWeight: E_FONT_WEIGHT.REGULAR,
        fontSize: '16px',
        lineHeight: '24px',
    },
    [E_FONT_SIZE_KEYS.MEDIUM_BOLD]: {
        fontWeight: E_FONT_WEIGHT.BOLD,
        fontSize: '16px',
        lineHeight: '24px',
    },
    [E_FONT_SIZE_KEYS.SMALL]: {
        fontWeight: E_FONT_WEIGHT.REGULAR,
        fontSize: '14px',
        lineHeight: '20px',
    },
    [E_FONT_SIZE_KEYS.SMALL_BOLD]: {
        fontWeight: E_FONT_WEIGHT.BOLD,
        fontSize: '14px',
        lineHeight: '20px',
    },
    [E_FONT_SIZE_KEYS.SMALLER]: {
        fontWeight: E_FONT_WEIGHT.REGULAR,
        fontSize: '12px',
        lineHeight: '18px',
    },
    [E_FONT_SIZE_KEYS.SMALLER_BOLD]: {
        fontWeight: E_FONT_WEIGHT.BOLD,
        fontSize: '12px',
        lineHeight: '18px',
    },
    [E_FONT_SIZE_KEYS.LINK_LARGE]: {
        fontSize: ['16px', '18px'],
        lineHeight: ['24px', '28px'],
        fontWeight: E_FONT_WEIGHT.REGULAR,
        fontFamily: E_FONT_FAMILY.DEFAULT,
    },
    [E_FONT_SIZE_KEYS.LINK_LARGE_BOLD]: {
        fontSize: ['16px', '18px'],
        lineHeight: ['24px', '28px'],
        fontWeight: E_FONT_WEIGHT.BOLD,
    },
    [E_FONT_SIZE_KEYS.LINK_MEDIUM]: {
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: E_FONT_WEIGHT.REGULAR,
    },
    [E_FONT_SIZE_KEYS.LINK_MEDIUM_BOLD]: {
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: E_FONT_WEIGHT.BOLD,
    },
    [E_FONT_SIZE_KEYS.LINK_SMALL]: {
        fontSize: '14px',
        lineHeight: '20px',
        fontWeight: E_FONT_WEIGHT.REGULAR,
    },
    [E_FONT_SIZE_KEYS.LINK_SMALL_BOLD]: {
        fontSize: '14px',
        lineHeight: '20px',
        fontWeight: E_FONT_WEIGHT.BOLD,
    },
    [E_FONT_SIZE_KEYS.NAVIGATION]: {
        fontSize: '18px',
        fontWeight: E_FONT_WEIGHT.LIGHT,
        fontFamily: E_FONT_FAMILY.TITLE,
        lineHeight: '26px',
    },
    [E_FONT_SIZE_KEYS.BUTTON]: {
        fontSize: '18px',
        fontWeight: E_FONT_WEIGHT.REGULAR,
        lineHeight: '28px',
    },
    [E_FONT_SIZE_KEYS.TABS]: {
        fontSize: ['14px', '18px'],
        lineHeight: ['20px', '28px'],
        fontWeight: E_FONT_WEIGHT.REGULAR,
    },
});
//# sourceMappingURL=font-faces.js.map